import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
  getHeader,
} from "../utils/setting";

import { checkResponse } from "../utils/checkResponse";
import jwt from "jsonwebtoken";

import { Cookies } from "react-cookie";
const cookie = new Cookies();
const serviceFeature = {
  state: {
    serviceFeature: [],
    feature: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async getFeatureForRole(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let decode = await jwt.decode(token);
      let url =
        DomainAPI + Channel + "/api/secure/serviceFeatures/getFeatureForRole";

      return fetch(url, {
        method: "POST",
        headers: getHeader(true, rootState.user.token),
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) {
            _this.setState({
              feature: result.data.feature,
              serviceFeature: result.data.service_feature,
            });
          }
          return result.code === 1 ? true : false;
        })
        .catch((err) => {
          return false;
        });
    },
    async updateFeature(payload, rootState) {
      const _this = this;
      let url =
        DomainAPI + Channel + "/api/secure/serviceFeatures/updateFeature";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          feature: Object.values(payload.data),
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then(async function (result) {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateServiceForAdmin(payload, rootState) {
      const _this = this;

      let url =
        DomainAPI +
        Channel +
        "/api/secure/serviceFeatures/updateServiceForAdmin";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({
          service: payload.data,
          feature: payload.feature,
          functions: payload.functions,
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result.code === 1 ? true : false;
        })
        .catch((error) => {
          return false;
        });
    },
  }),
};

export default serviceFeature;
